import React from 'react'
import styled from 'styled-components'

const AccessDeniedPage = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  font-family: Arial, sans-serif;
  color: #333;
  text-align: center;
  padding: 40px;

  .container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 40px;
    max-width: 600px;
    margin: auto;
  }

  img.logo {
    display: inline-block;
    width: 240px;
    margin-bottom: 30px;
  }

  h1 {
    color: #002d72;
  }

  a.new-url {
    color: #0073e6;
    font-weight: bold;
    text-decoration: none;
  }

  a.new-url:hover {
    text-decoration: underline;
  }

  .redirect-button {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 12px 24px;
    font-size: 16px;
    background-color: #add8e6;
    color: #002d72;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }

  .redirect-button:hover {
    background-color: #9acfe0;
  }
`

export class UrlAccessDenied extends React.PureComponent {

  render() {
    const {system} = this.props
    const url = new URL(system.systemWebHooks.systemAuthWebHook).origin
    return <AccessDeniedPage system={system}>
      <div class="container">
        <img class="logo" src="https://bucket.purview.net/purview-image.svg" alt="Purview Logo"/>
        <h1>Your Purview Image URL is changing!</h1>
        <p>The URL you are trying to access will soon be <strong>unavailable</strong>.</p>
        <p>Please update your bookmarks to use the new system URL below:</p>
        <p><a class="new-url" href={url}>{url}</a></p>
        <p>We appreciate your cooperation in keeping your access up-to-date.</p>
        <button
          class="redirect-button" onClick={() => {window.location.href=url}}
        >Click here to go your new Purview Image website
        </button>
        <p><strong>You will be asked to log in again on the new website.</strong></p>
        <p>Contact support@purview.net or</p>
        <p>call +1 (800) 501-1537 if you have any questions.</p>
      </div>
    </AccessDeniedPage>
  }
}